module.exports = __webpack_public_path__ + "img/homepage.4fd2ab77.svg";